import React, {useEffect, useState} from "react";

import { Box, Button, Checkbox, Column, Columns, Control, Field, Input, Select } from "@allxsmith/bestax-bulma";
import {formatDate} from "../../utils";
import GenerateFleetModal from "./GenerateFleetModal";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import VehicleMakePicker from "./VehicleMakePicker";
import VehicleModelPicker from "./VehicleModelPicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";


function VehicleInfoSection(props) {
  const [generateFleetModalState, setGenerateFleetModalState] = useState({modalOpen: false});
  const [isLoading, setLoading] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [hireCustomer, setHireCustomer] = useState();
  const [filteredModels, setFilteredModels] = useState(props.vehicleModel);
  const [, setTypeahead] = useState();
  const vehicleMake = props.vehicleMake;
  const departments = props.departments;

  useEffect(() => {
    handleModelFilter(props.data.make ? props.data.make : "");
  }, [props.data.make]);

  const vehicleMakeObjects = vehicleMake.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const vehicleModelObjects = filteredModels.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const departmentObjects = props.departmentObjects;

  const typeFields = props.vehicleTypes ? props.vehicleTypes.results : [];
  const typeObjects = typeFields.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const handleTypeUpdate = e => {
    const toUpdate = {
      target: {
        name: "type",
        value: typeObjects[e.target.value]
      }
    };
    props.onChange(toUpdate);
  };

  const handleDepartmentChange = e => {
    const toUpdate = {
      target: {
        name: "department",
        value: departmentObjects[e.target.value]
      }
    };
    props.onChange(toUpdate);
  }

  const handleSearch = e => {
    setLoading(true);
    axios.get(`/api/contacts?contact_type=CC&page_size=40&search=${e}`).then(resp => {
      setSearchData(resp.data.results);
      setLoading(false);
    });
  };

  const handleModelFilter = (make) => {
    const conf = {
      method: "get",
      url: "/api/vehiclemodel?page_size=1000&make="+(make ? make.id : "")
    }
    axios(conf).then(res => {
      setFilteredModels(res.data)
    })
  }


  const handleCustomerSelect = e => {
    const toUpdate = {
      target: {
        name: "hire_customer",
        value: e[0]
      }
    }
    props.onChange(toUpdate)
  }

  const handleMakeChange = e => {
    let isBlank = e.target.value === 'BLANK' && e.target.key === -1;
    const toUpdate = {
      target: {
        name: "make",
        value: isBlank ? {} : vehicleMakeObjects[e.target.value]
      }
    }
    props.onChange(toUpdate)
    handleModelFilter(isBlank ? null : vehicleMakeObjects[e.target.value])
  }
  const handleModelChange = e => {
    let isBlank = e.target.value === 'BLANK' && e.target.key === -1;
    const toUpdate = {
      target: {
        name: "model",
        value: isBlank ? {} : vehicleModelObjects[e.target.value]
      }
    }
    props.onChange(toUpdate)
  }

  const onHireCustomerClear = e => {
    const toUpdate = {
      target: {
        name: "hire_customer",
        value: null
      }
    }
    props.onChange(toUpdate)
  }

  return (
    <Box>
      <h1 className="title">Vehicle Info</h1>
      <Columns isMultiline>
        <Column>
          <Control>
            <label className="label">Vehicle Status</label>
            <Button
              color={
                props.data.vehicle_status === "EQUIPMENT" ? "primary" : ""
              }
              onClick={() => props.handleStatus("EQUIPMENT")}
            >
              Equipment
            </Button>
            <Button
              color={
                props.data.vehicle_status === "ACTIVE" ? "primary" : ""
              }
              onClick={() => props.handleStatus("ACTIVE")}
            >
              Active
            </Button>
            <Button
              color={
                props.data.vehicle_status === "ORDERED" ? "primary" : ""
              }
              onClick={() => props.handleStatus("ORDERED")}
            >
              Ordered
            </Button>
            <Button
              color={
                props.data.vehicle_status === "SALES_STOCK"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("SALES_STOCK")}
            >
              Sales Stock
            </Button>
            <Button
              color={
                props.data.vehicle_status === "FORSALE"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("FORSALE")}
            >
              For Sale
            </Button>
            <Button
              color={
                props.data.vehicle_status === "PENDING_SALE"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("PENDING_SALE")}
            >
              Pending Sale
            </Button>
            <Button
              color={
                props.data.vehicle_status === "PROCESSING"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("PROCESSING")}
            >
              Processing Sale
            </Button>
            <Button
              color={
                props.data.vehicle_status === "SOLD" ? "primary" : ""
              }
              onClick={() => props.handleStatus("SOLD")}
            >
              Sold
            </Button>
            <Button
              color={
                props.data.vehicle_status === "CUSTOMER"
                  ? "primary"
                  : ""
              }
              onClick={() => props.handleStatus("CUSTOMER")}
            >
              External Customer Vehicle
            </Button>
          </Control>
        </Column>
        <Column>
          <Field>
            <label className="label">LCV Sold</label>
            <input
              className="checkbox"
              type="checkbox"
              name="lcv_sold"
              onChange={props.handleCheckbox}
              checked={props.data.lcv_sold}
            />
          </Field>
        </Column>
        <Column>
            <label className="label">Sales Prep</label>
            <Checkbox
                name={"sales_prep"}
                checked={props.data.sales_prep}
                onChange={props.handleCheckbox}
                disabled={(props.data.vehicle_status !== "SALES_STOCK")}
            />
        </Column>
        <Column>
          <DepartmentSelector
            name={"department"}
            label={"Department"}
            value={props.data.department}
            options={departments}
            blank={false}
            disabled={false}
            classname={""}
            inlineEdit={false}
            editable={true}
            onChange={handleDepartmentChange}
          />
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
            <label className="label label">Registration</label>
            <Control>
              <Input
                type="text"
                name="registration"
                onChange={props.onChange}
                value={props.data.registration}
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <VehicleMakePicker
            onChange={handleMakeChange}
            vehicle={props.data}
            makes={vehicleMake}
          />
        </Column>
        <Column>
          <VehicleModelPicker
            onChange={handleModelChange}
            vehicle={props.data}
            models={filteredModels}
            showTitle={true}
            disabled={false}
          />
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Variant</label>
              <Input
                type="text"
                name="variant"
                onChange={props.onChange}
                value={props.data.variant}
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">VIN Number</label>
              <Input
                type="text"
                name="vin_number"
                onChange={props.onChange}
                value={props.data.vin_number}
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Type</label>
              <Select
                onChange={handleTypeUpdate}
                name="type"
                value={props.data.type ? props.data.type.id : 0}
              >
                <option key={0} value={0}></option>
                {typeFields.map(value => (
                  <option key={value.id} value={value.id}>
                    {value.name}
                  </option>
                ))}
              </Select>
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Date of First Registration</label>
              <Input
                type="date"
                name="first_registration_date"
                onChange={props.onChange}
                value={
                  props.data.first_registration_date
                  || ""
                }
              />
            </Control>
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <label className="label">Fleet Number</label>
          <Field className="has-addons">
            <Control>
              <Input
                type="text"
                name="fleet_number"
                onChange={props.onChange}
                value={props.data.fleet_number}
                required
              />
            </Control>
            <Control>
              <Button
                color={"success"}
                onClick={() => setGenerateFleetModalState({modalOpen: true})}
              >Generate</Button>
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Mileage</label>
            <Control>
              <Input
                type="number"
                name="mileage"
                onChange={props.onChange}
                value={String(props.data.mileage)}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Last Mileage Update</label>
              <Input
                type="date"
                name="mileage_last_updated"
                disabled
                readOnly
                value={
                  props.data.mileage_last_updated
                    ? formatDate(new Date(props.data.mileage_last_updated))
                    : ""
                }
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <label className="label">Company Car</label>
            <input
              className="checkbox"
              type="checkbox"
              name="company_vehicle"
              onChange={props.handleCheckbox}
              checked={props.data.company_vehicle}
            />
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Location</label>
              <Input
                type="text"
                name="location"
                onChange={props.onChange}
                value={props.data.location}
                required
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control>
              <label className="label">Purchase Date</label>
              <Input
                type="date"
                name="purchase_date"
                onChange={props.onChange}
                value={
                  props.data.purchase_date || ""
                }
              />
            </Control>
          </Field>
        </Column>
      </Columns>
      <Columns isMultiline>
        <Column>
          <Field>
              <label className="label">Hire Customer</label>
              <Control>
                <AsyncTypeahead
                  useCache={false}
                  data-testid="hire-customer-search"
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"hire_customer"}
                  onSearch={handleSearch}
                  onChange={handleCustomerSelect}
                  placeholder={"Search Customers"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                />
              </Control>
            </Field>
        </Column>
        <Column>
          <label className="label">Hire Customer Name</label>
          <Field className={"has-addons"}>
            <Control>
              <Input
                readOnly={true}
                disabled={true}
                value={props.data.hire_customer ? props.data.hire_customer.display_name : ""}
              />
            </Control>
            <Control>
              <Button
                color={"danger"}
                onClick={onHireCustomerClear}
              >
                Clear
              </Button>
            </Control>
          </Field>
        </Column>
        <Column/>
        <Column/>
        <Column/>
        <Column/>
      </Columns>
      <GenerateFleetModal
        {...generateFleetModalState}
        setModalState={setGenerateFleetModalState}
        endpoint={props.endpoint}
        onChange={props.onChange}
        initDate={props.data.delivery_date}
      />
    </Box>
  );
}

export default VehicleInfoSection;
